import React from 'react';
import { hrefForSameSiteAsset } from '../productMediaUtils';

/** Replace image extension with .webp for <source> — only for static JPEG/PNG files. */
function toWebpHref(href) {
  return href.replace(/\.(jpe?g|png)(\?.*)?$/i, '.webp$2');
}

/**
 * Product/category image from DB path only. Renders a neutral placeholder when missing.
 * Uses <picture> + WebP <source> when the path is a JPEG/PNG, falling back to the original.
 */
export default function CatalogImage({ src, alt = '', className = '', loading = 'lazy', sizes, style, width, height }) {
  const path = String(src || '').trim();
  if (!path) {
    return (
      <div
        className={`catalog-media-placeholder ${className}`.trim()}
        style={style}
        role="img"
        aria-label={alt || 'No image'}
      />
    );
  }
  const href = hrefForSameSiteAsset(path);
  const webpHref = toWebpHref(href);
  const hasWebp = webpHref !== href;
  const img = (
    <img
      src={href}
      alt={alt}
      className={className}
      loading={loading}
      sizes={sizes}
      style={style}
      width={width}
      height={height}
    />
  );
  if (!hasWebp) return img;
  return (
    <picture style={{ display: 'contents' }}>
      <source srcSet={webpHref} type="image/webp" sizes={sizes} />
      {img}
    </picture>
  );
}

